import { AppValueTypes } from '@iotv/iotv-v3-types';
import { GroupViewDefinition } from '../SytemManagement/Devices/DeviceGatewayGroupViewSubParts';
import { TeamRolesEnum } from '@iotv/datamodel-core';
export const TeamPersonViewDefinition = {
    ...GroupViewDefinition,
    role: {
        key: 'teamRole',
        label: 'Team Role',
        type: AppValueTypes.ENUM,
        enumKV: TeamRolesEnum,
        editable: true,
        unit: undefined,
        precision: undefined,
        stateFn: undefined,
        validationRx: undefined,
    },
};
